// maximum amount of content cards to show on desktop
export const MAX_ITEMS_TO_SHOW_ON_DESKTOP = 5;

// maximum amount of content cards to show on mobile
export const MAX_ITEMS_TO_SHOW_ON_MOBILE = 3;
